import { types } from '../types'

const initialState = {

    waitingGetInstruction: false,
    successGetInstruction: false,
    errorGetInstruction: '',

}



const secretaryReducer = (state = initialState, { type, action, error }) => {
    switch (type) {

        case types.GET_INSTRUCTION_REQUEST: {
            return {
                ...state,
                waitingGetInstruction: true,
                successGetInstruction: false,
            }
        }
        case types.GET_INSTRUCTION_ERROR: {
            return {
                ...state,
                waitingGetInstruction: false,
                errorGetInstruction: "error",
            }
        }
        case types.GET_INSTRUCTION_SUCCESS: {
            return {
                ...state,
                waitingGetInstruction: false,
                successGetInstruction: true,
                instruction: action.data

            }
        }


        case types.SET_USER_ONLINE_REQUEST: {
            return {
                ...state,
                waitingSetUserOnline: true,
                successSetUserOnline: false,
            }
        }
        case types.SET_USER_ONLINE_ERROR: {
            return {
                ...state,
                waitingSetUserOnline: false,
                errorSetUserOnline: "error",
            }
        }
        case types.SET_USER_ONLINE_SUCCESS: {
            return {
                ...state,
                waitingSetUserOnline: false,
                successSetUserOnline: true,

            }
        }


        case types.SET_USER_OFFLINE_REQUEST: {
            return {
                ...state,
                waitingSetUserOffline: true,
                successSetUserOffline: false,
            }
        }
        case types.SET_USER_OFFLINE_ERROR: {
            return {
                ...state,
                waitingSetUserOffline: false,
                errorSetUserOffline: "error",
            }
        }
        case types.SET_USER_OFFLINE_SUCCESS: {
            return {
                ...state,
                waitingSetUserOffline: false,
                successSetUserOffline: true,

            }
        }
        case types.INSTRUCTION_RESET_PROPS: {
            return {
                ...state,
                waitingGetInstruction: false,
                successGetInstruction: false,
                errorGetInstruction: '',
                waitingSetUserOnline: true,
                successSetUserOnline: false,
                errorSetUserOnline: "",
                waitingSetUserOffline: true,
                successSetUserOffline: false,
                errorSetUserOffline: "",

            }
        }
        default:
            return state
    }
}

export default secretaryReducer;